module.exports = __webpack_public_path__ + "img/insurance-logo-10.822ca69a.png";